
    <div class="row">
        <div class="col-sm-4">
            <textarea class="text-area-observacion-nivel" name="centroSalud" [(ngModel)]="centroSaludParbulos.centroSalud" [disabled]="readonly" ></textarea>
        </div>
        <div class="col-sm-4">
            <textarea class="text-area-observacion-nivel" name="direccion" [(ngModel)]="centroSaludParbulos.direccion" [disabled]="readonly" ></textarea>
        </div>
        <div class="col-sm-4">
            <textarea class="text-area-observacion-nivel" name="comunaLocalidad" [(ngModel)]="centroSaludParbulos.comunaLocalidad" [disabled]="readonly" ></textarea>
        </div>
    </div>
